export default "__VITE_ASSET__DKYY6FW8__"